import { MessagesSquare, RefreshCw, LineChart, Users } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";

const icons = [MessagesSquare, RefreshCw, LineChart, Users];

export const AICapabilities = () => {
  const { t } = useLang();
  const a = t.ai;
  return (
    <section className="py-20 md:py-28 bg-ink text-white" data-testid="ai-section">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <SectionHead label={a.label} title={a.title} center light />
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {a.items.map((it, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-7 h-full hover:bg-white/[0.06] transition-colors duration-300" data-testid={`ai-card-${i}`}>
                  <span className="w-12 h-12 rounded-2xl bg-tricolor-green/20 text-tricolor-green flex items-center justify-center">
                    <Icon size={24} />
                  </span>
                  <h3 className="mt-5 font-display font-bold text-lg text-white">{it.title}</h3>
                  <p className="mt-2 text-sm text-white/60 leading-relaxed">{it.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
